module.exports = __webpack_public_path__ + "img/credit-card-icons.9e964351.svg";